<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <div class="loading" v-if="loading"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'loadingDialog',
  components: {
  },
  data() {
    return {
      show: false,
      loading: true,
    };
  },
  methods: {
    open(d, n) {
      this.show = true;
    },
    close(b) {
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.46);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      // background-color: #fff;
      z-index: 2;
      text-align: center;
      overflow: hidden;
      max-width: none;

      border-radius: 50%;
      margin-top: -20px;
      height: 44px;
      width: 44px;

      // position: absolute;
      // top: 0; left: 0; right: 0; bottom: 0;
      .loading{
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: #fff;
        // background-color: rgba(255,255,255,.7);
        // backdrop-filter: saturate(180%) blur(20px);
        background-image: url(../assets/loading-3.svg);
        background-position: center;
        background-size: 50px auto;
        background-repeat: no-repeat;
        z-index: 9;
        &:before{
          content: "";
          position: absolute;
          left: 0; top: 0; right: 0; bottom: 0;
          background-image: url(../assets/cmsriver-logo-loading.png);
          background-size: 28px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
    }
  }
</style>
